@if (session(); as s) {
  <div class="page archery-spectator">
    <app-page-header
      kicker="ARCHERY · LIVE"
      [title]="s.name ?? 'Archery session'"
      [subtitle]="subtitleParts()"
    >
      <div slot="actions" class="archery-spectator__actions">
        <span class="brijjsports-badge brijjsports-badge--{{ statusTone() }}" [class.is-live]="isLive()">
          @if (isLive()) {
            <span class="archery-spectator__pulse" aria-hidden="true"></span>
          }
          {{ statusText() }}
        </span>
      </div>
    </app-page-header>

    <div class="brijjsports-stats">
      <app-stat-tile [value]="archerCount()" label="Archers" tone="blue" />
      @let leader = leadingRow();
      <app-stat-tile
        [value]="leader?.name ?? '—'"
        label="Leading"
        [sub]="leader ? leader.total + ' pts' : ''"
        tone="green"
      />
      <app-stat-tile [value]="topXs()" label="Top X count" tone="gold" />
      <app-stat-tile
        [value]="arrowsRecorded()"
        label="Arrows recorded"
        [sub]="arrowsCapacity() ? 'of ' + arrowsCapacity() : ''"
        tone="neutral"
      />
    </div>

    <section class="brijjsports-card">
      <header class="brijjsports-card__header">
        <h2 class="brijjsports-section-title">Leaderboard</h2>
      </header>

      @if (rows().length) {
        <ul class="brijjsports-li archery-spectator__rows">
          @for (r of rows(); track trackRow($index, r)) {
            <li>
              <div class="archery-spectator__lede">
                <span class="archery-spectator__rank" [attr.data-rank]="r.rank">{{ r.rank }}</span>
                <span class="brijjsports-av">{{ r.initials }}</span>
                <span class="archery-spectator__who">
                  <strong>{{ r.name }}</strong>
                  <small class="archery-spectator__meta">
                    {{ r.arrows }} arrows · {{ r.xs }} X · {{ r.tens }} tens
                  </small>
                </span>
              </div>
              <div class="archery-spectator__end">
                @if (r.pbr) {
                  <span class="brijjsports-badge brijjsports-badge--gold">PB</span>
                }
                <span class="archery-spectator__total">{{ r.total }}</span>
              </div>
            </li>
          }
        </ul>
      } @else {
        <div class="brijjsports-empty">
          <span class="brijjsports-empty__icon">🎯</span>
          <span class="brijjsports-empty__title">No scores recorded yet</span>
          <span>Scores will appear here as the coach records arrows.</span>
        </div>
      }
    </section>
  </div>
} @else {
  <div class="page">
    <div class="brijjsports-empty archery-spectator__missing">
      <span class="brijjsports-empty__icon">⚠️</span>
      <span class="brijjsports-empty__title">Session not found</span>
      <span>Check the link and try again.</span>
    </div>
  </div>
}
